import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Angular2TokenService } from 'angular2-token';
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { ActionCableService } from "./action-cable";
import { Observable } from "rxjs/Observable";
import { Enquiry } from "@models/enquiry";
import { Contact } from "@models/contact";

@Injectable()
export class EnquiryService {

  private enquiriesUrl: string = 'enquiries';

  constructor(
    private http: Angular2TokenService,
    private actionCableService: ActionCableService,
    private store: Store<AppState>,
  ) {}

  index(): Observable<Enquiry[]> {
    return this.http.get(this.enquiriesUrl)
      .map((res: Response) => res.json().map((e: any) => Enquiry.clone(e)))
      .catch((error: Response) => Observable.throw(error))
  }

  fetch(id: number): Observable<Enquiry> {
    return this.http.get(`${this.enquiriesUrl}/${id}`)
      .map((res: Response) => Enquiry.clone(res.json()))
      .catch((error: Response) => Observable.throw(error))
  }

  fetchByGuid(guid: string): Observable<Enquiry> {
    return this.http.get(`${this.enquiriesUrl}/by_guid/${guid}`)
      .map((res: Response) => Enquiry.clone(res.json()))
      .catch((error: Response) => Observable.throw(error))
  }

  create(enquiry: Enquiry): Observable<Enquiry> {
    return this.http.post(this.enquiriesUrl, enquiry)
      .map((res: Response) => Enquiry.clone(res.json()))
      .catch((error: Response) => Observable.throw(error))
  }

  update(enquiry: Enquiry): Observable<Enquiry> {
    return this.http.patch(`${this.enquiriesUrl}/${enquiry.id}`, enquiry)
      .map((res: Response) => Enquiry.clone(res.json()))
      .catch((error: Response) => Observable.throw(error))
  }

  convertEnquiryToContact(id: any, contactType: string): Observable<boolean> {
    return this.http.patch(`${this.enquiriesUrl}/${id}/convert_to_contact/${contactType}`, {})
      .map((res: Response) => res.json().result as boolean)
      .catch((error: Response) => Observable.throw(error))
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/enquiry.ts